import {Record} from 'immutable';
import {boolean, number, object, string} from "yup";

export const RoleRecord = Record({
    id: 0,
    name: '',
    description: '',
    grantCount: 0,
    locked: false
});

export const RoleSchema = object().shape({
    id: number().required().min(0).default(0),
    name: string().required().min(1).max(100).default(''),
    description: string().required().min(1).max(10000).default(''),
    grantCount: number().nullable().default(0),
    locked: boolean().required().default(false),
});